import React from 'react';
import { createPortal } from 'react-dom';
import './ConfirmationModal.css';

function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  children,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'danger',
  confirmDisabled = false,
  hideConfirm = false,
}) {
  React.useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && !confirmDisabled) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen, onClose, confirmDisabled]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (confirmDisabled) return;
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return createPortal(
    <div className="modal-overlay confirmation-modal-overlay" onClick={handleBackdropClick}>
      <div
        className="confirmation-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirmation-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="confirmation-modal-header">
          <h3 id="confirmation-modal-title">{title}</h3>
          <button
            type="button"
            className="modal-close"
            onClick={onClose}
            aria-label="Close"
            disabled={confirmDisabled}
          >
            ×
          </button>
        </div>
        <div className="confirmation-modal-body">
          {message != null && message !== "" && (
            typeof message === "string" ? <p>{message}</p> : message
          )}
          {children}
        </div>
        <div className="confirmation-modal-actions">
          <button
            type="button"
            className={hideConfirm ? "btn btn-primary" : "btn btn-secondary"}
            onClick={onClose}
            autoFocus
            disabled={confirmDisabled}
          >
            {cancelText}
          </button>
          {!hideConfirm && (
            <button
              type="button"
              className={`btn btn-${variant}`}
              onClick={onConfirm}
              disabled={confirmDisabled}
            >
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}

export default ConfirmationModal;
